export const ShopInventoryIdInitialState = {
  currentInventoryId: "",
};

export interface shopInventoryIdType {
  currentInventoryId?: string;
}
